import React, { FC } from 'react';
import { Props } from './types';

const ListIcon: FC<Props> = (props: Props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={props.fill}
      {...props}
    >
      <path
        d="M5.33331 28.5333V3.46666C5.33331 3.25448 5.4176 3.051 5.56763 2.90097C5.71766 2.75094 5.92114 2.66666 6.13331 2.66666H21.6693C21.8814 2.66684 22.0848 2.75125 22.2346 2.90132L26.432 7.09866C26.5066 7.17319 26.5658 7.26174 26.606 7.35922C26.6463 7.4567 26.6669 7.56119 26.6666 7.66666V28.5333C26.6666 28.6384 26.646 28.7424 26.6058 28.8395C26.5655 28.9365 26.5066 29.0247 26.4323 29.099C26.358 29.1733 26.2699 29.2322 26.1728 29.2724C26.0757 29.3126 25.9717 29.3333 25.8666 29.3333H6.13331C6.02826 29.3333 5.92423 29.3126 5.82717 29.2724C5.73011 29.2322 5.64191 29.1733 5.56763 29.099C5.49334 29.0247 5.43441 28.9365 5.39421 28.8395C5.35401 28.7424 5.33331 28.6384 5.33331 28.5333Z"
        stroke="#80A2B1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21.3333 2.66666V7.19999C21.3333 7.41216 21.4176 7.61565 21.5676 7.76567C21.7177 7.9157 21.9211 7.99999 22.1333 7.99999H26.6666"
        stroke="#80A2B1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <rect x="8" y="10.6667" width="2.66667" height="2.66667" fill="#80A2B1" />
      <rect x="8" y="16" width="2.66667" height="2.66667" fill="#80A2B1" />
      <rect x="8" y="21.3333" width="2.66667" height="2.66667" fill="#80A2B1" />
      <rect x="12" y="10.6667" width="12" height="2.66667" fill="#80A2B1" />
      <rect x="12" y="16" width="12" height="2.66667" fill="#80A2B1" />
      <rect x="12" y="21.3333" width="12" height="2.66667" fill="#80A2B1" />
    </svg>
  );
};
export default ListIcon;
